import React from 'react';
import { t } from '@lingui/macro';
import { Chip, CHIP_VARIANTS } from '@toqio/toqio-web-components';
import type { CardStatus } from '../types';

/**
 * Card status pill. Mapping from the source desktop card form (CDSC_F008
 * `statusMapping`) — PRD §5: several raw statuses collapse onto one
 * label/variant. The label is translatable; the status key is not.
 */
const STATUS_MAP: Record<
  CardStatus,
  { label: () => string; variant: (typeof CHIP_VARIANTS)[keyof typeof CHIP_VARIANTS] }
> = {
  ACTIVE: { label: () => t`ACTIVE`, variant: CHIP_VARIANTS.SUCCESS },
  ISSUED: { label: () => t`ISSUED`, variant: CHIP_VARIANTS.WARNING },
  AWAITING: { label: () => t`ISSUED`, variant: CHIP_VARIANTS.WARNING },
  SUSPENDED: { label: () => t`BLOCKED`, variant: CHIP_VARIANTS.WARNING },
};

export const StatusChip: React.FC<{ status: CardStatus; size?: 'm' | 's' }> = ({
  status,
  size = 's',
}) => {
  const mapping = STATUS_MAP[status];
  return (
    <Chip size={size} variant={mapping.variant}>
      {mapping.label()}
    </Chip>
  );
};
